import { useState } from "react"

import { ToastContainer, toast } from "react-toastify"

import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';

import styles from './styles.module.css'

import { authApi } from "../../services/api/api"
import useAuth from "../../hooks/useAuth"

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Comment from "../comment"
import TextEditor from "../textEditor";
import { ChatBubbleOutline, Favorite, FavoriteBorder, Warning } from "@mui/icons-material";
import { Info, MessageCircle, Pen, Send, Trash2 } from "lucide-react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
export default function Post({ post, handleSetPostComment, atualizar, setAtualizar }: any) {

    const api = authApi()

    const { user, theme } = useAuth()

    const [likes, setLikes] = useState(post.likes)

    const [liked, setLiked] = useState(post.like ? true : false)

    const [text, setText] = useState(post.description ?? '')

    const [textComment, setTextComment] = useState('')

    const [open, setOpen] = useState(false);

    const themeMui = useTheme();

    const isMobile = useMediaQuery(themeMui.breakpoints.down('sm'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };


    async function setComment() {

        if (text === '') {
            toast.error('Preencha o comentário!', { theme: 'dark', toastId: 'valid_text' })
            return
        }

        toast.loading('Carregando...', { theme: 'dark', toastId: 'load_comment' })

        if (user) {

            const data = {
                'user': user.id,
                'post': post.id,
                'text': textComment
            }

            await handleSetPostComment(data)
        }
        handleClose()
        toast.dismiss('load_comment')
    }

    async function handleLikePost() {


        if (user) {
            const response = await api.likePost(user.id, post.id)

            if (response === 200) {

                setLikes(likes + 1)
                setLiked(true)
            } else {
                setLikes(likes - 1)
                setLiked(false)
            }
        }
    }


    async function handleDelete() {
        const response = await api.destroyPost(post.id)


        if (response == 200) {
            toast.success('Publicação excluida com sucesso.', { theme: 'dark', toastId: 'deleteSuccsess' })
            setAtualizar(!atualizar)
            handleClose1()
            return
        }
        handleClose1()
        toast.info('Não foi possível excluir a publicação.', { theme: 'dark', toastId: 'errorDelete' })
    }

    async function handleUpdate() {

        const data = {
            id: post.id,
            text: text
        }

        toast.loading('Carregando.', { theme: 'dark', toastId: 'loadUpdate' })

        const response = await api.updatePost(data)

        if (response == 200) {
            toast.dismiss('loadUpdate')
            setAtualizar(!atualizar)
            handleClose2()
        } else {
            toast.dismiss('loadUpdate')
            toast.error('Não foi possivel atualizar a indicação.', { theme: 'dark', toastId: 'erroUpdate' })
        }

    }

    return (
        <div className="w-full mt-4 bg-white dark:bg-[#0d2d5f]/30 rounded-[2rem] shadow-sm border border-gray-100 dark:border-white/5 overflow-hidden mb-8 transition-all hover:shadow-md">
            <div className="px-6 py-4 flex items-center bg-gray-50/50 justify-between dark:bg-[#2d3d5780] border-b border-gray-50 dark:border-white/5 relative">
                <div className="flex items-center gap-3">
                    <div className="relative">
                        <img
                            src={post.user?.img ?? require("../../assets/logos/logo-icon.png")}
                            alt="perfil"
                            className="w-12 h-12 rounded-full  border-2 border-blue3 shadow-sm bg-white dark:border-blue-500"
                        />
                    </div>
                    <div>
                        <h3 className="text-sm font-bold text-gray-900 dark:text-blue-50 leading-none mb-1">
                            {post.user?.name ?? "Usuário Desconhecido"}
                        </h3>
                        <p className="text-[10px] text-gray-400 font-medium uppercase tracking-widest flex gap-1 items-start  dark:text-blue-300/60">
                            Publicou em <span>{Intl.DateTimeFormat('pt-BR').format(new Date(post.created_at))}</span>
                        </p>
                    </div>
                </div>

                {/* Ações Administrativas */}
                {post.user_id == user.id && (
                    <div className="flex absolute top-6 right-5 gap-2">
                        <button onClick={handleClickOpen2} className=" text-gray-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-400/10 rounded-xl transition-all">
                            <Pen size={15} />
                        </button>
                        <button onClick={handleClickOpen1} className=" text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-400/10 rounded-xl transition-all">
                            <Trash2 size={15} />
                        </button>
                    </div>
                )}
            </div>

            {/* Conteúdo Principal */}
            <div className="p-6">
                <div className="flex flex-col md:flex-row gap-8">

                    {/* Bloco do Livro/Imagem */}
                    <div className="shrink-0 flex flex-col items-center gap-4">
                        <div className="relative group">
                            <img
                                src={post.book?.img ?? post.img}
                                alt="capa"
                                className="w-32 h-48 object-cover rounded-2xl shadow-xl transition-transform group-hover:scale-105 duration-500 ring-1 ring-black/5 dark:ring-white/10"
                            />
                        </div>
                        <button
                            onClick={handleClickOpen}
                            className="w-full py-2 text-[10px] font-black uppercase tracking-[0.2em] text-blue-600 dark:text-blue-400 dark:bg-white/5 hover:bg-blue-50 dark:hover:bg-blue-400/10 rounded-lg transition-colors border border-blue-100 dark:border-blue-400/20"
                        >
                            Comentar
                        </button>
                    </div>

                    {/* Texto e Sinopse */}
                    <div className="flex-1 min-w-0">
                        <div className="mb-4">
                            <h2 className="text-2xl font-black text-gray-900 dark:text-white leading-tight capitalize tracking-tight">
                                {post.book?.title ?? post.title}
                            </h2>
                            {post.book?.autor && (
                                <p className="text-sm text-blue-600 dark:text-blue-400 font-medium italic">
                                    {post.book.autor}
                                </p>
                            )}
                        </div>

                        <div className="relative">
                            {/* Container de texto com fundo sutil para melhorar leitura no dark */}
                            <div
                                className={`text-sm text-gray-700 dark:text-blue-50/80 leading-relaxed overflow-auto pr-4 custom-scrollbar dark:bg-white/10 dark:p-3 dark:rounded-xl`}
                                style={{ maxHeight: '400px' }}
                                dangerouslySetInnerHTML={{ __html: post.description }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Rodapé de Interações */}
            <div className="px-6 py-4 bg-gray-50/50 dark:bg-[#2d3d5780] flex items-center justify-between border-t border-gray-50 dark:border-white/5">
                <div className="flex items-center gap-6">
                    <button
                        onClick={handleLikePost}
                        className={`flex items-center gap-2 group transition-all ${liked ? 'text-red-600' : 'text-gray-400 hover:text-red-500'}`}
                    >
                        <div className={`p-2 rounded-full transition-colors ${liked ? 'bg-red-50 dark:bg-red-500/10' : 'group-hover:bg-gray-100 dark:group-hover:bg-white/5'}`}>
                            {liked ? <Favorite fontSize="small" /> : <FavoriteBorder fontSize="small" />}
                        </div>
                        <span className="text-sm font-bold dark:text-blue-100">{likes}</span>
                    </button>

                    <div className="flex items-center gap-2 text-gray-400 group cursor-pointer dark:hover:text-blue-400 transition-colors">
                        <div className="p-2 rounded-full group-hover:bg-gray-100 dark:group-hover:bg-white/5">
                            <ChatBubbleOutline fontSize="small" />
                        </div>
                        <span className="text-sm font-bold dark:text-blue-100">{post?.comment?.length ?? 0}</span>
                    </div>
                </div>
            </div>

            {/* Seção de Comentários Aninhada - Fundo contrastante */}
            {post?.comment?.length > 0 && (
                <div className="bg-gray-50/30 dark:bg-[#061c3f]/30 p-6 border-t border-gray-50 dark:border-white/5 space-y-4 shadow-inner">
                    {post.comment.map((item: any) => (
                        <Comment
                            atualizar={atualizar}
                            setAtualizar={setAtualizar}
                            key={item.id}
                            item={item}
                        />
                    ))}
                </div>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen={isMobile}
                PaperProps={{
                    style: {
                        borderRadius: isMobile ? '0px' : '24px',
                        backgroundImage: 'none',
                        maxWidth: '600px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header com Identidade Visual do Fórum */}
                <div className="bg-gradient-to-r from-blue1 to-blue3 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <MessageCircle className="text-white" size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-blue-200/70 block mb-0.5">
                                Participar da Conversa
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Responder Tópico
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8 pb-4">
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center gap-2 mb-1">
                            <label className="text-[11px] uppercase font-bold tracking-widest text-gray-400">
                                Seu comentário
                            </label>
                        </div>

                        <div className="rounded-2xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner focus-within:border-blue-500/40 transition-all">
                            <TextEditor setText={setTextComment} />
                        </div>


                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-4 border-t border-gray-100">
                    <div className="flex w-full my-2">
                        <button
                            onClick={handleClose}
                            className="flex-1 h-12 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest uppercase"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={setComment}
                            className="flex-[2] h-12 bg-blue2 hover:bg-blue3 text-white text-xs font-bold rounded-xl shadow shadow-blue-500/30 transition-all active:scale-95 uppercase tracking-widest flex items-center justify-center gap-2"
                        >
                            Enviar Comentário
                        </button>
                    </div>
                </DialogActions>
            </Dialog>


            {/* modal de exclusão */}
            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '24px',
                        backgroundImage: 'none',
                        maxWidth: '450px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header de Alerta (Vermelho Vibrante) */}
                <div className="bg-gradient-to-r from-[#7f1d1d] to-[#ef4444] px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <Trash2 className="text-white" size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-red-200/70 block mb-0.5">
                                Ação Irreversível
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Confirmar Exclusão
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8 pb-4 text-center">
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-16 h-16 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-2">
                            <Warning className="text-red-500" sx={{ fontSize: 32 }} />
                        </div>

                        <h2 className="text-lg font-bold text-slate-800 dark:text-white">
                            Você tem certeza disso?
                        </h2>

                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed px-4">
                            Ao excluir esta publicação, todos os comentários e curtidas associados serão removidos permanentemente.
                        </p>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex flex-col sm:flex-row gap-3 border-t border-gray-100">
                    {/* Botão Cancelar agora é o foco secundário */}
                    <div className="flex my-2 w-full ">
                        <button
                            onClick={handleClose1}
                            className="w-full h-12 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest uppercase order-2 sm:order-1"
                        >
                            Manter Post
                        </button>

                        {/* Botão Deletar com destaque total */}
                        <button
                            onClick={handleDelete}
                            className="w-full h-12 bg-red-600 hover:bg-red-700 text-white text-xs font-bold rounded-xl shadow-lg shadow-red-500/30 transition-all active:scale-95 uppercase tracking-widest flex items-center justify-center gap-2 order-1 sm:order-2"
                        >
                            Sim, Excluir tudo
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            {/* modal de edição */}
            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '24px',
                        backgroundImage: 'none',
                        maxWidth: '700px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header com tom de Edição (Azul Profundo/Indigo) */}
                <div className="bg-gradient-to-r from-blue1 to-blue3 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <EditIcon className="text-white" style={{ fontSize: 22 }} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-indigo-200/70 block mb-0.5">
                                Modo de Edição
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Refinar Publicação
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8">
                    <div className="flex flex-col gap-4">
                        {/* Aviso Sutil de Edição */}
                        <div className="flex items-center gap-3 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800/30 mb-2">
                            <Info className="text-blue-500" size={17} />
                            <p className="text-[11px] text-blue-700 dark:text-blue-300 font-medium">
                                Suas alterações serão refletidas imediatamente no fórum após salvar.
                            </p>
                        </div>

                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                Conteúdo do Post
                            </label>
                            <div className="rounded-2xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner focus-within:border-indigo-500/40 transition-all">
                                <TextEditor text={text} setText={setText} />
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-4 border border-t-gray-100">
                    {/* Botão Cancelar Secundário */}
                    <div className="w-full my-2 flex">
                        <button
                            onClick={handleClose2}
                            className="flex-1 h-12 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest uppercase"
                        >
                            Descartar
                        </button>

                        {/* Botão Atualizar Principal */}
                        <button
                            onClick={handleUpdate}
                            className="flex-[2] h-12 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl shadow-lg shadow-indigo-500/30 transition-all active:scale-95 uppercase tracking-widest flex items-center justify-center gap-2"
                        >
                            Salvar Alterações
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )
}